var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.notificacoes),function(notificacao,index){return [_c('div',{staticClass:"dropdown-divider"}),_c('notificacao-item',{key:'notif-' + index,attrs:{"titulo":notificacao.titulo,"descricao":notificacao.descricao,"data":notificacao.data,"url":notificacao.url}})]}),_c('a',{attrs:{"href":"#"}},[_vm._v("ver todas")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }